var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrontpageTopright(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 248,
    height: 721.831,
    viewBox: "0 0 248 721.831",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M413,949.831v0h0a602.206,602.206,0,0,1-102.031-97.261,625.63,625.63,0,0,1-78.219-120.112,639.737,639.737,0,0,1-28.832-67.193,647.046,647.046,0,0,1-21.261-71.188A655.635,655.635,0,0,1,169.5,519.461a668.419,668.419,0,0,1,0-154.922,655.667,655.667,0,0,1,13.153-74.611c4.939-20.842,10.989-41.677,17.982-61.928H413V949.831Z",
    transform: "translate(-165 -228)",
    fill: "#edf8f2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontpageTopright);
export default __webpack_public_path__ + "static/media/frontpage_topright.75fe469aa94794102568b92cd410e743.svg";
export { ForwardRef as ReactComponent };